import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(() => ({
  page: {
    display: "block",
    margin: "150px 0 0 620px",
  },
  table: {
    display: "block",
    margin: "50px auto",
  },
  chart: {
    display: "block",
    margin: "20px auto",
  },
}));

export default useStyles;
